var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux/node_modules/lodash/_Symbol.js
// module id = 276
// module chunks = 0